export default {
  setNotification(state, notification) {
        state.notification = notification;
    }
}